module.exports = __webpack_public_path__ + "img/updated.089d6f8f.png";